module.exports = __webpack_public_path__ + "static/media/self.9cb5c10e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/self.jpg
// module id = 26
// module chunks = 0